import { TextField } from '@material-ui/core';
import styled from 'styled-components';

export const Input = styled(TextField)`
	&& {
		margin-right: 10px;
	}
`;

export const Container = styled.div`
	display: flex;
	align-items; center;
	justify-content: center;
`;
